import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';
import { Menu } from 'lucide-react';
import lanerunnerLogoWhite from '@/assets/lanerunner-logo-white.png';

interface LandingMobileNavProps {
  onLogin: () => void;
  onSignup: () => void;
  /** Optional override for the hamburger trigger colours (used by the homepage transparent nav). */
  triggerClassName?: string;
}

const LandingMobileNav: React.FC<LandingMobileNavProps> = ({ onLogin, onSignup, triggerClassName }) => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { label: 'HOME', href: '/', key: 'home' },
    
    { label: 'LOADBOARD', href: '/load-board', key: 'load-board' },
    { label: 'SHIPPERS', href: '/shippers', key: 'shippers' },
    { label: 'BROKERS', href: '/brokers', key: 'brokers' },
    { label: 'CARRIERS', href: '/carriers', key: 'carriers' },
    { label: 'PARTNERS', href: '/partner-program', key: 'partner-program' },
    { label: 'PRICING', href: '/pricing', key: 'pricing' },
  ];


  return (
    <Sheet open={isOpen} onOpenChange={setIsOpen}>
      <SheetTrigger asChild>
        <Button 
          variant="ghost" 
          size="icon" 
          className={`lg:hidden h-10 w-10 transition-colors ${triggerClassName ?? 'text-gray-900 hover:bg-gray-100'}`}
        >
          <Menu className="h-6 w-6" />
          <span className="sr-only">Toggle menu</span>
        </Button>
      </SheetTrigger>
      <SheetContent 
        side="left" 
        className="w-[280px] p-0 flex flex-col border-r border-border bg-background"
      >
        <SheetHeader className="p-4 border-b border-border">
          <SheetTitle className="flex items-center justify-between">
            <Link to="/" onClick={() => setIsOpen(false)} className="inline-flex items-center">
              <img 
                src={lanerunnerLogoWhite} 
                alt="LaneRunner" 
                className="h-7"
              />
            </Link>
          </SheetTitle>
        </SheetHeader>

        <nav className="flex-1 py-4">
          {navLinks.map((link) => {

            return (
              <Link
                key={link.key}
                to={link.href}
                onClick={() => setIsOpen(false)}
                className="flex items-center px-6 py-4 text-sm font-medium text-foreground hover:bg-accent hover:text-lr-cyan transition-colors"
              >
                {link.label}
              </Link>
            );
          })}
        </nav>

        <div className="p-4 border-t border-border space-y-3">
          <Button
            variant="outline"
            onClick={() => { setIsOpen(false); onLogin(); }}
            className="w-full rounded-full border-[#02857E]/40 text-[#02857E] bg-transparent hover:bg-[#02857E]/10 hover:border-[#02857E] font-semibold"
          >
            SIGN IN
          </Button>
          <Button
            onClick={() => { setIsOpen(false); onSignup(); }}
            className="w-full rounded-full bg-[#02857E] text-white font-semibold hover:bg-[#026d67]"
          >
            SIGN UP
          </Button>
        </div>
      </SheetContent>
    </Sheet>
  );
};

export default LandingMobileNav;
